<template>
  <div id="index">
    <!-- <Hezuo></Hezuo> -->

    <div class="visible-xs min_index">
      <header class="flex_center m_header">
        <i
          class="esc"
          @click="goBackward"
        ><img
            src="@/assets/img/esc_fan.png"
            alt=""
          ></i>
        <h4 class="header_title">收藏</h4>
        <i
          class="rigth_button"
          @click.stop="state = true"
          v-if="!state"
        >
          管理
        </i>
        <span
          class="rigth_button"
          v-else
          @click.stop="state = false"
        >
          取消
        </span>
      </header>
      <!-- 内容 -->
      <div class="poure34">
        <div
          @click.stop="openre(0)"
          :class="{acticls43:is_cate34===0}"
        >文章分类</div>
        <div
          @click.stop="openre(1)"
          :class="{acticls43:is_cate34===1}"
        >视频分类</div>
      </div>
      <div class='integral_div'>
        <div
          class="list_ul"
          v-if="is_cate34===0&&list_ul.length>0"
        >
          <div
            class="list_li flex_between"
            :class="{'selsected':liem.is_selected&&state}"
            @click="detailsFun(index)"
            v-for="(liem,index) in list_ul"
            :key="liem.id"
          >
            <i
              class="gou_icon"
              v-if="state"
            >
              <img
                v-if="!liem.is_selected"
                src="@/assets/img/gou.png"
                alt=""
              >
              <img
                v-else
                src="@/assets/img/gouT.png"
                alt=""
              >
            </i>
            <!-- <div class="list_li_text">
                            <h3 class="list_title">
                                <span class="list_tag" v-for="lise in liem.lable"
                                    :style="{'color':lise.color,'border-color':lise.color}">{{lise.title}}</span>
                            </h3>
                            <h5 class="li_title clamp1">
                                {{liem.title}}
                            </h5>
                            <div class="li_text clamp2" v-html="liem.content">

                            </div>
                            <div class="bottom_li flex_between">
                                <div class="buttom_left flex_center">
                                    <div class="tag_li flex_center">
                                        <i><img src="@/assets/img/yanT.png" alt=""></i>
                                        {{liem.see}}
                                    </div>
                                    <div class="tag_li flex_center">
                                        <i><img src="@/assets/img/dianzhanP.png" alt=""></i>
                                        {{liem.goods}}
                                    </div>
                                    <div class="tag_li flex_center">
                                        <i><img src="@/assets/img/pinglunP.png" alt=""></i>
                                        {{liem.comment}}
                                    </div>

                                </div>
                                <span class="li_time">
                                    {{liem.create_time}}
                                </span>
                            </div>
                        </div> -->
            <!-- 左边摘要 -->
            <div
              class="list_left flex_between div_zuoyou"
              v-if="liem.summary_location == 3"
            >

              <h2 class="list_title clamp1">{{liem.title}}</h2>
              <h3 class="list_title list_time flex_start">
                <span
                  class="list_tag"
                  v-for="lise in liem.lable"
                  :style="{'color':lise.color,'border-color':lise.color}"
                >{{lise.title}}</span>
                <div class="time_right">
                  <span class="original">原创:{{liem.user}}</span>
                  <span class="time">{{liem.create_time}}</span>
                </div>
              </h3>
              <div class="flex_between text_div">
                <div
                  class="list_describe clamp3"
                  v-html="liem.content"
                >
                </div>
                <div
                  class="list_right flex_center"
                  v-if="liem.cover_video"
                  @click.stop=""
                >
                  <i class="contain_video">
                    <video
                      controlslist='nodownload'
                      :poster="liem.video_image?liem.video_image:'@/assets/img/app_logo.png'"
                      x5-video-player-fullscreen="true"
                      webkit-playsinline="true"
                      x-webkit-airplay="true"
                      playsinline="true"
                      x5-playsinline
                      oncontextmenu="return false"
                      ref="video"
                      :src="liem.cover_video"
                      preload
                      controls
                    ></video>
                  </i>
                </div>
                <div
                  class="list_right flex_center"
                  v-else
                >
                  <i
                    class="flex_center contain_img"
                    v-if="indexT<2"
                    v-for="(liemT,indexT) in liem.cover"
                  >
                    <img
                      :src="liemT"
                      alt=""
                    >
                  </i>
                </div>

              </div>
              <div class="list_time flex_between">

                <div class="flex_center operation">
                  <div class="flex_center operation_li">
                    <i><img
                        src="@/assets/img/liulanP.png"
                        alt=""
                      ></i>
                    {{liem.see}}
                  </div>
                  <div class="flex_center operation_li">
                    <i><img
                        src="@/assets/img/dianzhanP.png"
                        alt=""
                      ></i>
                    {{liem.goods}}
                  </div>
                  <div class="flex_center operation_li">
                    <i><img
                        src="@/assets/img/pinglunP.png"
                        alt=""
                      ></i>
                    {{liem.comment}}
                  </div>
                </div>

              </div>
            </div>
            <!-- 右边摘要 -->
            <div
              class="list_rigth list_left flex_between div_zuoyou"
              v-if="liem.summary_location == 4"
            >
              <h2 class="list_title clamp1">{{liem.title}}</h2>
              <h3 class="list_title list_time flex_start">
                <span
                  class="list_tag"
                  v-for="lise in liem.lable"
                  :style="{'color':lise.color,'border-color':lise.color}"
                >{{lise.title}}</span>
                <div class="time_right">
                  <span class="original">原创:{{liem.user}}</span>
                  <span class="time">{{liem.create_time}}</span>
                </div>
              </h3>
              <div class="flex_between text_div">
                <div
                  class="list_right flex_center"
                  v-if="liem.cover_video"
                  @click.stop=""
                >
                  <i class="contain_video">
                    <video
                      controlslist='nodownload'
                      :poster="liem.video_image?liem.video_image:'@/assets/img/app_logo.png'"
                      x5-video-player-fullscreen="true"
                      webkit-playsinline="true"
                      x-webkit-airplay="true"
                      playsinline="true"
                      x5-playsinline
                      oncontextmenu="return false"
                      ref="video"
                      :src="liem.cover_video"
                      preload
                      controls
                    ></video>
                  </i>
                </div>
                <div
                  class="list_right flex_center"
                  v-else
                >
                  <i
                    class="flex_center contain_img"
                    v-if="indexT<2"
                    v-for="(liemT,indexT) in liem.cover"
                  >
                    <img
                      :src="liemT"
                      alt=""
                    >
                  </i>
                </div>
                <div
                  class="list_describe clamp3"
                  v-html="liem.content"
                >
                </div>
              </div>
              <div class="list_time flex_between">

                <div class="flex_center operation">
                  <div class="flex_center operation_li">
                    <i><img
                        src="@/assets/img/liulanP.png"
                        alt=""
                      ></i>
                    {{liem.see}}
                  </div>
                  <div class="flex_center operation_li">
                    <i><img
                        src="@/assets/img/dianzhanP.png"
                        alt=""
                      ></i>
                    {{liem.goods}}
                  </div>
                  <div class="flex_center operation_li">
                    <i><img
                        src="@/assets/img/pinglunP.png"
                        alt=""
                      ></i>
                    {{liem.comment}}
                  </div>
                </div>
              </div>
            </div>
            <!-- 上边摘要 -->
            <div
              class="list_top list_left flex_between"
              v-if="liem.summary_location == 1"
            >
              <h2 class="list_title clamp1">{{liem.title}}</h2>
              <h3 class="list_title list_time flex_start">
                <span
                  class="list_tag"
                  v-for="lise in liem.lable"
                  :style="{'color':lise.color,'border-color':lise.color}"
                >{{lise.title}}</span>
                <div class="time_right">
                  <span class="original">原创:{{liem.user}}</span>
                  <span class="time">{{liem.create_time}}</span>
                </div>
              </h3>
              <div class="text_div">
                <div
                  class="list_describe clamp2"
                  v-html="liem.content"
                >
                </div>
                <div
                  class="list_right flex_center"
                  v-if="liem.cover_video"
                  @click.stop=""
                >
                  <i class="contain_video">
                    <video
                      controlslist='nodownload'
                      oncontextmenu="return false"
                      :poster="liem.video_image?liem.video_image:'@/assets/img/app_logo.png'"
                      x5-video-player-fullscreen="true"
                      webkit-playsinline="true"
                      x-webkit-airplay="true"
                      playsinline="true"
                      x5-playsinline
                      ref="video"
                      :src="liem.cover_video"
                      preload
                      controls
                    ></video>
                  </i>
                </div>
                <div
                  class="list_right "
                  v-else
                >
                  <i
                    class="flex_center contain_img"
                    :class="{'max' : liem.cover.length == 1}"
                    v-if="indexT<4"
                    v-for="(liemT,indexT) in liem.cover"
                  >
                    <img
                      :src="liemT"
                      alt=""
                    >
                  </i>
                </div>

              </div>
              <div class="list_time flex_between">

                <div class="flex_center operation">
                  <div class="flex_center operation_li">
                    <i><img
                        src="@/assets/img/liulanP.png"
                        alt=""
                      ></i>
                    {{liem.see}}
                  </div>
                  <div class="flex_center operation_li">
                    <i><img
                        src="@/assets/img/dianzhanP.png"
                        alt=""
                      ></i>
                    {{liem.goods}}
                  </div>
                  <div class="flex_center operation_li">
                    <i><img
                        src="@/assets/img/pinglunP.png"
                        alt=""
                      ></i>
                    {{liem.comment}}
                  </div>
                </div>
              </div>
            </div>

            <!-- 下边摘要 -->
            <div
              class="list_top list_left flex_between"
              v-if="liem.summary_location == 2"
            >
              <h2 class="list_title clamp1">{{liem.title}}</h2>
              <h3 class="list_title list_time flex_start">
                <span
                  class="list_tag"
                  v-for="lise in liem.lable"
                  :style="{'color':lise.color,'border-color':lise.color}"
                >{{lise.title}}</span>
                <div class="time_right">
                  <span class="original">原创:{{liem.user}}</span>
                  <span class="time">{{liem.create_time}}</span>
                </div>
              </h3>
              <div class="text_div">
                <div
                  class="list_right flex_center"
                  v-if="liem.cover_video"
                  @click.stop=""
                >
                  <i class="contain_video">
                    <video
                      controlslist='nodownload'
                      oncontextmenu="return false"
                      :poster="liem.video_image?liem.video_image:'@/assets/img/app_logo.png'"
                      x5-video-player-fullscreen="true"
                      webkit-playsinline="true"
                      x-webkit-airplay="true"
                      playsinline="true"
                      x5-playsinline
                      ref="video"
                      :src="liem.cover_video"
                      preload
                      controls
                    ></video>
                  </i>
                </div>
                <div
                  class="list_right"
                  v-else
                >
                  <i
                    class="flex_center contain_img"
                    :class="{'max' : liem.cover.length == 1}"
                    v-if="indexT<4"
                    v-for="(liemT,indexT) in liem.cover"
                  >
                    <img
                      :src="liemT"
                      alt=""
                    >
                  </i>
                </div>
                <div
                  class="list_describe clamp2"
                  v-html="liem.content"
                >
                </div>
              </div>
              <div class="list_time flex_between">

                <div class="flex_center operation">
                  <div class="flex_center operation_li">
                    <i><img
                        src="@/assets/img/liulanP.png"
                        alt=""
                      ></i>
                    {{liem.see}}
                  </div>
                  <div class="flex_center operation_li">
                    <i><img
                        src="@/assets/img/dianzhanP.png"
                        alt=""
                      ></i>
                    {{liem.goods}}
                  </div>
                  <div class="flex_center operation_li">
                    <i><img
                        src="@/assets/img/pinglunP.png"
                        alt=""
                      ></i>
                    {{liem.comment}}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div
          class="list_ul12 flex_between"
          v-if="is_cate34===1&&list_ul.length>0"
        >
          <div
            class="list_li12 flex_center"
            :class="{'selsected':liem.is_selected&&state}"
            @click.stop="detailsFunvedio(index,liem.id)"
            v-for="(liem,index) in list_ul"
            :key="liem.id"
          >
            <i
              class="gou_icon"
              v-if="state"
            >
              <img
                v-if="!liem.is_selected"
                src="@/assets/img/gou.png"
                alt=""
              >
              <img
                v-else
                src="@/assets/img/gouT.png"
                alt=""
              >
            </i>
            <i class="li_icon">
              <img
                v-if="liem.cover"
                :src="liem.cover"
                alt=""
              >
              <img
                v-else
                src="@/assets/img/app_logo.png"
                alt=""
              ></i>
            <h4>{{liem.title}}</h4>
          </div>
        </div>
        <div
          class="no_center flex_center"
          v-if="list_ul.length===0"
        >
          <i v-if="is_loading&&!idloading"><img
              src="@/assets/img/kkry_pc.gif"
              alt=""
            ></i>
          <div
            class="flex_center prompt_text"
            v-if="is_loading&&!idloading"
          >
            暂无收藏，前往推荐看看吧! <a
            v-if="is_cate34===0"
              href="javaScript:void(0)"
              @click.stop="geHome(0)"
            >推荐</a>
            <a
            v-else
              href="javaScript:void(0)"
              @click.stop="geHome(1)"
            >推荐</a>
          </div>
          <div
            v-if="idloading"
          >
            <div >
              <div class="spinner-box">
                <img
                  src="@/assets/img/loadding_pc.gif"
                  alt=""
                >
                <div>努力加载中...</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="bottom_button flex_between"
        v-if="state"
      >
        <!-- <div
          class="flex_center button_left"
          @click="reinstall(1)"
        >
          <i> <img
              v-if="!is_selected"
              src="@/assets/img/gou.png"
              alt=""
            >
            <img
              v-else
              src="@/assets/img/gouT.png"
              alt=""
            >
          </i>
          全选
        </div> -->
        <button
          v-if="is_cate34===0"
          class="flex_center button_right"
          @click="delFun"
          :class="{'point':selsected_arr.length>0}"
        >取消收藏</button>
        <button
          v-if="is_cate34===1"
          class="flex_center button_right"
          @click="delFunvideo"
          :class="{'point':selsected_arr.length>0}"
        >取消收藏</button>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/js/swiper.animate1.0.3.min.js";
import "@/assets/css/animate.min.css";
import "@/assets/css/video-js.min.css";
import Hezuo from '@/components/tool/m_hezuo.vue'

export default {
  name: "my_collection",
  data () {
    return {
      user: {},//用户信息
      state: false,//是否管理
      list_ul: [],
      page: 1,
      is_selected: false,//全选
      selsected_arr: [],//删除

      is_loading: false,
      idloading:true,
      is_cate34: 0
    };
  },
  computed: {},
  components: {
    Hezuo
  },
  watch: {

  },
  methods: {
    openre (id) {
      this.idloading=true
       
      this.is_cate34 = id
      this.state = false
      this.list_ul = []
      this.getList()
      this.selsected_arr = []
    },
    detailsFun (index) {//查看详情
      if (this.state) {
        this.list_ul[index].is_selected = !this.list_ul[index].is_selected;
        this.reinstall();
      } else {
        this.$router.push({ path: '/m_column_details', query: { id: this.list_ul[index].news_id, head_index: 2 } });
      }
    },
     detailsFunvedio(index){
       if (this.state) {
        this.list_ul[index].is_selected = !this.list_ul[index].is_selected;
         this.reinstall();
      } else {
        this.$router.push({ path: '/m_vedio_dteil', query: { id: this.list_ul[index].video_id, configid: this.list_ul[index].video_conf_id } });
      }

    },
    delFun () {
      if (this.selsected_arr.length <= 0) {
        return false;
      }
      let that = this;
      layer.open({
        content: '确定要取消收藏吗？'
        , style: 'background-color:#fff; color:#33333;font-size:18px; border:none;' //自定风格
        , btn: ['确定', '取消']
        , yes: function (index) {
          // location.reload();
          layer.close(index);
          that.$post('collect', {
            news_id: that.selsected_arr.join(","),
            member_id: that.USER().id,
            type: 2,
          }).then(res => {
            layer.open({
              content: "取消收藏成功",
              time: true,
              skin: "msg"
            });
            that.state = false;
            that.page = 1;
            that.is_selected = false
            that.getList();
          })
        }
      });
    },
    delFunvideo () {
      if (this.selsected_arr.length <= 0) {
        return false;
      }
       
      let that = this;
      layer.open({
        content: '确定要取消收藏吗？'
        , style: 'background-color:#fff; color:#33333;font-size:18px; border:none;' //自定风格
        , btn: ['确定', '取消']
        , yes: function (index) {
          // location.reload();
          layer.close(index);
          that.$post('collect', {
            video_id: that.selsected_arr.join(","),
            member_id: that.USER().id,
            type: 2,
          }).then(res => {
            layer.open({
              content: "取消收藏成功",
              time: true,
              skin: "msg"
            });
            that.state = false;
            that.page = 1;
            that.is_selected = false
            that.getList();
          })
        }
      });
    },
    reinstall (type) {//组装数据
      this.selsected_arr = [];
      let that = this;
      this.list_ul.forEach((element, index) => {
        if (type == 1 && !this.is_selected) {
          that.list_ul[index].is_selected = true;
        }
        if (type == 1 && this.is_selected) {
          that.list_ul[index].is_selected = false;
        }
        if (that.list_ul[index].is_selected) {
          if (that.is_cate34 === 0) {
            that.selsected_arr.push(element.news_id);
          } else {
            that.selsected_arr.push(element.video_id);
          }
        }
      });
      if (this.selsected_arr.length >= this.list_ul.length) {
        this.is_selected = true;
      } else {
        this.is_selected = false;
      }
    },
    geHome (id) {//返回首页
      if(id===0){
      this.$router.replace('/m_column');
    }else{
      this.$router.replace('/m_vedio_index');
    }
    },
    goBackward () {//返回上一页
      this.$router.push({name:'m_my'})
    },
    getUser () {
      let that = this;
      this.REFRESH_USER();
      that.user = this.USER();
      this.getList();
    },
    getList () {
      let that = this;
      if (this.page == 1) {
        this.list_ul = [];
      }
      this.$post('follow_comment', {
        type: 3,//1评论2关注3收藏
        member_id: this.USER().id,
      }).then(res => {
      this.idloading=false
        that.is_loading = true;
        let arr = []
        if (this.is_cate34 === 0) {
          arr.push(...res.data.news)
        } else {
          arr.push(...res.data.video)
        }
        if (arr) {
          arr.forEach((element, index) => {
            arr[index].is_selected = false;
          });
        }
        that.list_ul = arr
        // that.$nextTick(() => {
        //   that.videoFun();
        // })
      })
    },
    videoFun () {
       
      var au = document.getElementsByTagName("video");
      for (var i = 0; i < au.length; i++) {
        au[i].addEventListener("playing", function () {
          var this1 = this;
          this.play();
          for (var b = 0; b < au.length; b++) {
            var this2 = au[b];
            if (this1 !== this2) {
              this2.pause();
            }
          }
        });
      }
    },

  },
  mounted () {
    this.getUser();
    this.getShare();

    if (this._isMobile()) {

    } else {
      // alert("pc端");
      this.$router.replace("/");
    }
    let that = this;
    $(window).scroll(function () {
      var scrollTop = $(this).scrollTop();
      var scrollHeight = $(document).height();
      var windowHeight = $(this).height();
      //   if (scrollTop + windowHeight + 2 >= scrollHeight) {
      //     that.page++;
      //     that.getList();
      //   }
    });
  }
};
</script>

<style scoped>
html,
body {
  max-width: 100vw;
  background: #f9fbfe;
}

.visible-xs {
  width: 100vw;
  overflow: hidden;
  padding-top: 0rem;
}

/* 内容 */
.list_ul {
  background: #f9fbfe;
  
}
.list_ul12{
font-size: 0;
  flex-wrap: wrap;
  padding: 0px 1rem;
}


.list_ul .list_li {
  position: relative;
  padding: 1rem 1.4rem;
  margin-bottom: 0.6rem;
  background: #fff;
  border-bottom: 0.05rem solid #dfdfdf;
}

.list_ul .list_li .list_li_text {
  width: calc(100vw - 2.8rem);
}

.list_ul .list_li .li_title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-top: 0.6rem;
  color: #333;
}

.list_ul .list_li .li_text {
  font-size: 1.3rem;
  color: #666;
  margin: 0.6rem 0;
}

.list_ul .list_li .bottom_li {
  margin-top: 1rem;
}

.list_ul .list_li .bottom_li .tag_li {
  margin-right: 1.4rem;
}

.list_ul .list_li .bottom_li .tag_li i {
  width: 1.6rem;
  margin-right: 0.6rem;
  font-size: 1.2rem;
  color: #999;
}

.list_ul .list_li .gou_icon {
  width: 1.8rem;
  height: 1.8rem;
  margin-right: 1rem;
}

.list_ul .list_li .li_icon {
  width: 6.5rem;
  height: 6.5rem;
  margin-bottom: 2rem;
  overflow: hidden;
}

.list_ul .list_li > h4 {
  font-size: 1.8rem;
  font-weight: bold;
  color: #f5ab16;
}

/* 底部按钮 */
.bottom_button {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4.5rem;
  background: #fff;
  box-shadow: 0 0 9px rgba(71, 71, 71, 0.11);
}

.bottom_button .button_left {
  padding-left: 1.5rem;
  height: 100%;
  font-size: 1.4rem;
  color: #999;
}

.bottom_button .button_left > i {
  width: 1.4rem;
  margin-right: 0.9rem;
}

.bottom_button .button_right {
  width: 100%;
  height: 100%;
  background: #bfbfbf;
  color: #fff;
  font-size: 1.4rem;
  border: 0;
}

.bottom_button .button_right.point {
  background: #f24d5b;
}

.list_title > .list_tag {
  border-radius: 0.2rem;
  border: 0.05rem solid #9749bb;
  color: #9749bb;
  font-size: 1.1rem;
  margin-right: 0.7rem;
  padding: 0 0.7rem;
  line-height: 1.7rem;
  height: 1.7rem;
}

/* 暂无数据 */
.no_center {
  flex-direction: column;
  /* padding-top: 50vh;
  transform: translateY(-50%); */
}

.no_center > i {
  width: 80vw;
  margin-bottom: 2.5rem;
}

.no_center .prompt_text {
  font-size: 1.4rem;
  color: #666;
}

.no_center .prompt_text > a {
  color: #f24d5b;
  margin-left: 10px;
}
/* 列表 */
.list_left {
  flex-direction: column;
  flex: 1;
  align-items: flex-start;
}

.list_left .list_title {
  font-size: 1.5rem;
  color: #333;
  font-weight: bold;
  align-items: flex-start;
  line-height: 1.1em;
  margin: 0.4rem 0;
}

.list_left .list_title > .list_tag {
  border-radius: 0.2rem;
  border: 0.05rem solid #9749bb;
  color: #9749bb;
  display: inline-flex;
  font-size: 1.1rem;
  margin-right: 0.7rem;
  padding: 0 0.7rem;
  line-height: 2rem;
  height: 2rem;
}
.list_left .list_title.list_time .time_right {
  font-weight: normal;
  margin-left: 1rem;
}
.list_left .list_title.list_time .time_right {
  font-weight: normal;
  margin-left: 1rem;
}
.list_time .operation .operation_li {
  font-size: 1.2rem;
  color: #999;
  margin-right: 1.4rem;
  white-space: nowrap;
  line-height: 1.1em;
}
.list_time .original {
  font-size: 1.1rem;
  color: #999;
  margin-right: 12px;
}
.list_time .time {
  font-size: 1.1rem;
  color: #999;
}

.list_time .operation .operation_li > i {
  width: 1.2rem;
  margin-right: 4px;
}
.text_div {
  width: 100%;
}
/* 左边摘要 */

.div_zuoyou.list_left .text_div {
  width: 100%;
  margin: 0.6rem 0;
}

.div_zuoyou.list_left .text_div .list_describe {
  flex: 1;
  height: 100%;
  height: 6.4rem;
}

.div_zuoyou.list_left .text_div .list_right {
  width: auto;
}

.div_zuoyou.list_left .text_div .list_right .contain_img {
  width: 10rem;
  height: 7.2rem;
  margin: 0 0 0 1rem;
  background: transparent;
}

.div_zuoyou.list_left .text_div .list_right .contain_img > img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.div_zuoyou.list_left .text_div .list_right .contain_video {
  width: 18rem;
  height: 10rem;
  margin-right: 1rem;
}
.div_zuoyou.list_left .text_div .list_right .contain_video > video {
  width: 100%;
}
/* 右边摘要 */
.div_zuoyou.list_rigth .text_div .list_right .contain_img {
  margin: 0 1rem 0 0;
}
.div_zuoyou.list_rigth .text_div .list_right .contain_video {
  width: 18rem;
  height: 10rem;
  margin-left: 1rem;
}
/* <!-- 上边摘要 --> */
.list_top.list_left .text_div {
  margin-top: 1rem;
}

.list_top.list_left .list_describe {
  width: 100%;
}

.list_top.list_left .list_right {
  width: 100%;
  flex-wrap: wrap;
}
.list_top.list_left .text_div .list_right .contain_img {
  width: calc(25% - 1rem);
}
.list_top.list_left .text_div .list_right .contain_video {
  width: 100%;
  height: auto;
}
.list_top.list_left .text_div .list_right .contain_video > video {
  width: 100%;
}
.list_top.list_left .list_right i {
  width: calc(33% - 1rem);
  height: 6rem;
  margin: 0 1rem 1rem 0;
  display: inline-flex;
}

.list_top.list_left .list_right i > img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.list_top.list_left .text_div .list_right .contain_img.max {
  width: 100%;
  height: auto;
}
.poure34 {
  display: flex;
  justify-content: space-around;
}
.poure34 div {
  padding: 10px 0px;
  border-bottom: #ffffff00 2px solid;
}
.acticls43 {
  border-bottom: #f24d5b 2px solid !important;
}
.list_li12{
    width: calc(50% - 2rem);
  height: 15.8rem;
  border: 1px solid #999999;
  position: relative;
  flex-direction: column;
  display: inline-flex;
  border-radius: 1rem;
  margin: 1rem 0px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
}
.list_li12.selsected {
  border-color: #f24d5b;
}
.list_li12 .gou_icon {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 1.8rem;
  height: 1.8rem;
}
.list_li12 .li_icon {
  width: 11.5rem;
  height: 6.5rem;
  font-size: 0;
  margin-bottom: 2rem;
  overflow: hidden;
}
.list_li12 > h4 {
    text-align: center;
    width: 100%;
    height: 3rem;
    overflow: hidden;
  font-size: 1rem;
  font-weight: bold;
  color: #f5ab16;
}
.li_icon>img{
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>


// WEBPACK FOOTER //
// src/components/min_view/m_collection.vue